const {app, Menu} = require("electron");
//chrome 命令行写在 ready 前
app.commandLine.appendSwitch("--disable-http-cache");
app.commandLine.appendSwitch("disable-web-security");
const api = require("./common/api");

global.main_path = __dirname;

if (app.requestSingleInstanceLock && !app.requestSingleInstanceLock()) {
	app.quit();
} else {
	// 单实例运行
	app.on("second-instance", function () {
		let win = global.mainWindow;
		if (win) {
			if (win.isMinimized()) win.restore();
			win.focus();
		}
	});
	//然后去ready里面去调用
	app.on("ready", function () {
		Menu.setApplicationMenu(null);
		api.createAnimationWindow();
		global.mainWindow = api.createWindow();
		if (process.platform == "win32") {
			app.setPath("userData", process.cwd());
		}
	});
	// 接口调用
	const ipc = require("electron").ipcMain;
	for (let k in api) {
		let fn = api[k];
		if (typeof fn === "function") {
			ipc.on("api." + k, function (e, data) {
				Promise.resolve()
					.then(() => fn.apply(e.sender.getOwnerBrowserWindow(), data.args))
					.then((x) => e.sender.send(data.cb, null, x))
					.catch((x) => e.sender.send(data.cb, x));
			});
		}
	}
	app.on("window-all-closed", function () {
		app.exit();
	});
}
